import useFetchClientAccountList from '@/hooks/useApi/useFetchClientAccountList';
import { useEffect, useRef, useState } from 'react';

import { BillPaymentIFrameEvent, BillPaymentIFrameMethod } from 'vopay';
import { useClientData } from '@/providers/ClientData.provider';
import useGenerateBillPayEmbedUrl from '@/hooks/useApi/useGenerateBillPayEmbedUrl';
import { useBranding } from '@/providers/Branding.provider';
import { useDataFetchIndicator } from '@/hooks';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

const BillPayment: React.FC = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [, dataFetchIndicator] = useDataFetchIndicator();
  const { primaryColor } = useBranding();
  const { userSettings } = useUserSettingsProvider();
  const {
    response: { clientAccountsEnabled },
  } = useClientData();

  const [isLoaded, setIsLoaded] = useState(false);
  const [, , , fetchClientAccounts] = useFetchClientAccountList({});
  const { link, generateBillPayEmbedUrl } = useGenerateBillPayEmbedUrl();

  const postMessageToIframe = (message: BillPaymentIFrameMethod) => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage(message, '*');
    }
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent<BillPaymentIFrameEvent>) => {
      // if (event.origin !== 'http://localhost:4175') return; should do add later
      if (!event.data) return;
      const { type } = event.data;
      if (type === 'READY_FOR_MESSAGES') {
        postMessageToIframe({
          type: 'SET_CONFIG',
          payload: {
            primaryColor: primaryColor,
            timezone: userSettings.timezone,
            fullScreenLoader: false,
          },
        });
      }
      if (type === 'CONFIG_PROCESSED') {
        dataFetchIndicator(false);
        setIsLoaded(true);
      }
      if (type == 'LOADING') {
        const { completed } = event.data.payload;
        dataFetchIndicator(!completed);
      }
    };

    dataFetchIndicator(true);
    // Add event listener for messages
    window.addEventListener('message', handleMessage);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    const fetchAccounts = async () => {
      if (clientAccountsEnabled) {
        const clientAccountsRes = await fetchClientAccounts({
          ClientType: '',
        });

        if (!clientAccountsRes.Success) throw new Error(clientAccountsRes.ErrorMessage);

        const primaryClientAccount = Object.values(clientAccountsRes.ClientAccounts || {}).find(
          (obj) => obj.IsPrimaryAccount === '1',
        );

        if (!primaryClientAccount) return;
        const { ClientAccountID } = primaryClientAccount;
        generateBillPayEmbedUrl({
          ClientAccountID: ClientAccountID,
        });
      } else {
        generateBillPayEmbedUrl({});
      }
    };

    fetchAccounts();
  }, []);

  return (
    <>
      {link && (
        <iframe
          ref={iframeRef}
          src={link}
          title="Bill Payment Iframe"
          style={{ width: '100%', height: '100%', border: 'none', visibility: isLoaded ? 'visible' : 'hidden' }}
          allow="clipboard-write"
          seamless
        ></iframe>
      )}
    </>
  );
};

export default BillPayment;
